import { FC } from 'react';
import { SharedResourceTabs } from '@client/features/shared-resources/shared-resource-tabs';
import { LayoutsGrid } from './layouts-grid';

export type ManageTradingLayoutsProps = {
  activeLayoutId?: string;
  onApply: (layoutId: string) => void;
  onDelete: (layoutIds: string[]) => void;
  onModify: (
    layoutId: string,
    layoutName: string,
    layoutNotes?: string
  ) => void;
  onSetDefault: (layoutId: string, isDefault: boolean) => void;
  onShare?: (layoutId: string, layoutName: string) => void;
  onImportShared: (
    sharedResourceId: string,
    sharedResourceName: string
  ) => void;
  onModifyShared: (
    sharedResourceId: string,
    sharedResourceName: string,
    sharedResourceNotes?: string
  ) => void;
  onRevokeShared: (sharedResourceId: string) => void;
};

export const ManageTradingLayouts: FC<ManageTradingLayoutsProps> = ({
  activeLayoutId,
  onApply,
  onDelete,
  onModify,
  onSetDefault,
  onShare,
  onImportShared,
  onModifyShared,
  onRevokeShared
}) => {
  return (
    <SharedResourceTabs
      sharedResourceType="tradingLayout"
      onImportShared={onImportShared}
      onModifyShared={onModifyShared}
      onRevokeShared={onRevokeShared}
      renderMine={() => (
        <LayoutsGrid
          activeLayoutId={activeLayoutId}
          onApply={onApply}
          onDelete={onDelete}
          onModify={onModify}
          onSetDefault={onSetDefault}
          onShare={onShare}
        />
      )}
    />
  );
};
